<template>
  <div
    class="accordion accordion-solid accordion-toggle-plus"
    id="accordion-form-one-signal"
  >
    <div class="card m-3">
      <div class="card-header">
        <div
          class="card-title collapsed py-3 pr-10 font-weight-normal"
          data-toggle="collapse"
          data-target="#collapse_one_signal"
        >
          <span>
            {{ $tc("ADVANCED_SETTINGS.DOMAIN.CONFIG_ONE_SIGNAL.TITLE") }}
          </span>
        </div>
      </div>

      <div
        id="collapse_one_signal"
        class="collapse"
        data-parent="#accordion-form-one-signal"
      >
        <div class="card-body">
          <div
            v-if="hasAccess('oneSignal', 'read')"
            class="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center mb-3"
          >
            <label class="mr-2 w-25">{{
              $tc("ADVANCED_SETTINGS.DOMAIN.CONFIG_ONE_SIGNAL.LABEL_ID")
            }}</label>

            <div class="d-flex flex-column w-75">
              <b-form-input
                v-model="form.oneSignal.id"
                :placeholder="
                  $tc('ADVANCED_SETTINGS.DOMAIN.CONFIG_ONE_SIGNAL.LABEL_ID')
                "
                class="form-control--grey"
                :disabled="!hasAccess('oneSignal', 'write')"
              />
            </div>
          </div>

          <div
            v-if="hasAccess('oneSignal', 'read')"
            class="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center mb-3"
          >
            <label class="mr-2 w-25">{{
              $tc("ADVANCED_SETTINGS.DOMAIN.CONFIG_ONE_SIGNAL.LABEL_AUTH")
            }}</label>

            <div class="d-flex flex-column w-75">
              <b-form-input
                v-model="form.oneSignal.auth"
                :placeholder="
                  $tc('ADVANCED_SETTINGS.DOMAIN.CONFIG_ONE_SIGNAL.LABEL_AUTH')
                "
                class="form-control--grey"
                :disabled="!hasAccess('oneSignal', 'write')"
              />
            </div>
          </div>

          <div
            v-if="hasAccess('oneSignal', 'read')"
            class="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center mb-3"
          >
            <label class="mr-2 w-25">{{
              $tc("ADVANCED_SETTINGS.DOMAIN.CONFIG_ONE_SIGNAL.LABEL_DATABASE")
            }}</label>

            <div class="d-flex flex-column w-75">
              <b-form-input
                v-model="form.oneSignal.db"
                :placeholder="
                  $tc(
                    'ADVANCED_SETTINGS.DOMAIN.CONFIG_ONE_SIGNAL.LABEL_DATABASE'
                  )
                "
                class="form-control--grey"
                :disabled="!hasAccess('oneSignal', 'write')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import auth from "@/store/auth.module";
import { getAttributesRead, hasAttributeAccess } from "@/common/config/acl";
import { FORM_ONE_SIGNAL } from "@/common/config/acl/domain/oneSignal";

export default {
  props: {
    domainId: {
      type: String,
      required: false
    },
    formProps: {
      type: Object,
      required: false
    }
  },

  data() {
    return {
      user: auth.state.user,
      form: getAttributesRead(FORM_ONE_SIGNAL, auth.state.user.roles)
    };
  },

  mounted() {
    if (this.domainId) {
      this.form = this.formProps;

      if (this.form.oneSignal) {
        this.form.oneSignal.id = this.formProps.oneSignal.id
          ? this.formProps.oneSignal?.id.toString()
          : "false";
        this.form.oneSignal.auth = this.formProps.oneSignal.auth
          ? this.formProps.oneSignal?.auth.toString()
          : "false";
        this.form.oneSignal.pushMigration = this.formProps.oneSignal
          .pushMigration
          ? this.formProps.oneSignal?.pushMigration.toString()
          : "false";
      }
    }
  },

  methods: {
    hasAccess(field, accessType) {
      return hasAttributeAccess(
        FORM_ONE_SIGNAL,
        this.user.roles,
        field,
        accessType
      );
    },
    resetData() {
      this.form = getAttributesRead(FORM_ONE_SIGNAL, this.user.roles);
    }
  }
};
</script>
